import { Component, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modale-resultat',
  templateUrl: './modale-resultat.component.html',
  styleUrls: ['./modale-resultat.component.scss'],
  standalone: false
})

export class ModaleResultatComponent {
  titre: string;
  resultat: string;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  fermerModale() {
    this.event.emit();
    this.bsModalRef.hide();
  }
}
